import { queryOptions, skipToken } from "@tanstack/react-query";

import { MASTER_INVALIDATION_KEY } from "@/api/queryClient";
import {
  getCurrentWorkspaceInvitations,
  getWorkspaceInvitationsInvited,
} from "@/api/resources/workspaceInvitations/api";
import i18n from "@/providers/i18n";

const entities = i18n.t("workspace-invitations");
const entitiesErrorMessage = {
  text: i18n.t("notify.error-reason.unexpected"),
  title: i18n.t("notify.get.error", { e: entities }),
};

export const workspaceInvitationsQueryKeys = {
  all: () => [...MASTER_INVALIDATION_KEY, "workspaceInvitations"],
  lists: () => [...workspaceInvitationsQueryKeys.all(), "list"],
  listCurrent: (workspace_id?: string) => [...workspaceInvitationsQueryKeys.lists(), "current", workspace_id],
  listInvited: (email?: string) => [...workspaceInvitationsQueryKeys.lists(), "invited", email],
};
export const workspaceInvitationsQueries = {
  listCurrent: (workspace_id?: string) =>
    queryOptions({
      queryKey: [...workspaceInvitationsQueryKeys.listCurrent(workspace_id)],
      queryFn: workspace_id ? () => getCurrentWorkspaceInvitations(workspace_id) : skipToken,

      meta: {
        errorMessage: entitiesErrorMessage,
      },
    }),
  listInvited: (email?: string) =>
    queryOptions({
      queryKey: [...workspaceInvitationsQueryKeys.listInvited(email)],
      queryFn: email ? () => getWorkspaceInvitationsInvited(email) : skipToken,

      meta: {
        errorMessage: entitiesErrorMessage,
      },
    }),
};
